import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AccessTokenInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Le token n'est envoyé qu'à notre API, jamais à un tiers
        const token = localStorage.getItem('qwin-accessToken');
        const isApiRequest = req.url.startsWith(environment.webappBaseUrl) || req.url.startsWith(environment.uploadBaseUrl);
        if (isApiRequest && token && token.length > 0) {
            const clonedRequest = req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) });
            return next.handle(clonedRequest);
        }

        return next.handle(req);
    }
}